import { removeStopwords } from '../typography';
import { SPEAKING_URL_TITLE_MAX_LENGTH } from './constants';
export var trimAtWordEnd = function (string, maxLength) {
    if (string.length < maxLength) {
        return string;
    }
    var trimmedString = string.substr(0, maxLength);
    if (trimmedString.lastIndexOf(' ') === -1) {
        return trimmedString;
    }
    return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
};
export var getSpeakingUrlText = function (text) {
    if (!text) {
        return null;
    }
    var trimmedText = trimAtWordEnd(text.replace(/[^0-9a-z ]/gi, ''), SPEAKING_URL_TITLE_MAX_LENGTH)
        .toLowerCase()
        .split(' ');
    var textWithStopWordsRemoved = removeStopwords(trimmedText).join('-');
    return textWithStopWordsRemoved.length < 5
        ? trimmedText.join('-')
        : textWithStopWordsRemoved;
};
export var getInitials = function (fullName) {
    var names = (fullName && fullName.split(' ')) || [''];
    var initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};
//# sourceMappingURL=utils.js.map